import React from 'react';

const CardMockup = () => {
  return (
    <div className="relative flex justify-center items-center py-8">
      {/* Glow effect behind card */}
      <div
        className="absolute w-80 h-48 rounded-3xl blur-3xl opacity-30"
        style={{ background: 'linear-gradient(135deg, #14B8A6, #3B82F6, #10B981)' }}
      />

      {/* Card */}
      <div
        className="relative w-80 h-48 rounded-2xl p-6 flex flex-col justify-between shadow-2xl overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, #0d9488 0%, #1d4ed8 50%, #059669 100%)',
          boxShadow: '0 25px 50px rgba(20, 184, 166, 0.35), 0 0 0 1px rgba(255,255,255,0.08)'
        }}
      >
        {/* Noise texture overlay */}
        <div
          className="absolute inset-0 rounded-2xl opacity-10"
          style={{
            backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\'/%3E%3C/svg%3E")',
            backgroundSize: '150px'
          }}
        />

        {/* Shimmer lines */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden rounded-2xl">
          <div
            className="absolute -top-20 -left-20 w-64 h-64 rounded-full opacity-10"
            style={{ background: 'radial-gradient(circle, rgba(255,255,255,0.8) 0%, transparent 70%)' }}
          />
          <div
            className="absolute -bottom-16 -right-16 w-48 h-48 rounded-full opacity-10"
            style={{ background: 'radial-gradient(circle, rgba(255,255,255,0.6) 0%, transparent 70%)' }}
          />
        </div>

        {/* Top row: Logo + chip */}
        <div className="relative flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img
              src="/assets/images/image-1772733559968.png"
              alt="SocialCents logo"
              className="h-6 w-auto object-contain brightness-0 invert"
            />
          </div>
          {/* Chip */}
          <div
            className="w-8 h-6 rounded-sm opacity-80"
            style={{ background: 'linear-gradient(135deg, #fbbf24, #f59e0b)' }}
          />
        </div>

        {/* Card number */}
        <div className="relative">
          <p
            className="text-white text-lg tracking-widest font-mono opacity-90"
            style={{ letterSpacing: '0.2em', fontFamily: 'JetBrains Mono, monospace' }}
          >
            •••• &nbsp;•••• &nbsp;•••• &nbsp;••••
          </p>
        </div>

        {/* Bottom row */}
        <div className="relative flex items-end justify-between">
          <div>
            <p className="text-white/50 text-xs uppercase tracking-widest mb-0.5">Expires</p>
            <p className="text-white text-sm font-medium tracking-wider" style={{ fontFamily: 'JetBrains Mono, monospace' }}>MM / YY</p>
          </div>
          <div className="flex items-center gap-1">
            {/* Mastercard-style circles */}
            <div className="w-7 h-7 rounded-full bg-red-500 opacity-80" />
            <div className="w-7 h-7 rounded-full bg-yellow-400 opacity-80 -ml-3" />
          </div>
        </div>

        {/* Coming Soon ribbon */}
        <div
          className="absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-semibold text-white"
          style={{
            background: 'rgba(255,255,255,0.15)',
            backdropFilter: 'blur(8px)',
            border: '1px solid rgba(255,255,255,0.25)'
          }}
        >
          Coming Soon
        </div>
      </div>
    </div>
  );
};

export default CardMockup;
